import type { BaseResource, QcsSyncResourceStore } from '../core/resourceStoreTypes';

export type PaymentMethodProps = BaseResource & {
  token?: string | null;
  deleted?: boolean | null;
  defaultMethod?: boolean | null;
  isDeclined?: boolean | null;
  isHardDeclined?: boolean | null;
};

export type PaymentMethodsStore = QcsSyncResourceStore<PaymentMethodProps>;

export const PAYMENT_METHODS_REDUCER_KEY = 'paymentMethodsStore' as const;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [PAYMENT_METHODS_REDUCER_KEY]: PaymentMethodsStore;
  }
}
